import { ITableCell } from "./interfaces";
import { Tcell } from "./Tcell";

export const Trow = (props: { isHead?: boolean; data: ITableCell[] }) => {
  const { data, isHead } = props;
  
  return (
    <tr className="rounded-md">
      {data.map((cell, index) => (
        <Tcell key={index.toString()} cell={cell} isHead={isHead} />
      ))}
    </tr>
  );
};
